import { faChartBar } from '@fortawesome/free-regular-svg-icons'
import { faListUl, faShoppingBasket } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import Style from './BottomNavigation.module.css'
import {Link} from 'react-router-dom'
const BottomNavigation = () => {
    useEffect(()=>{
        if(window.location.pathname==='/')
        {
            setShoppingBasket(false)
            setDashboard(true)
            setMenu(false)  
        }
        if(window.location.pathname==='/orders')
        {
            setShoppingBasket(true)
            setDashboard(false)
            setMenu(false)  
        }
        if(window.location.pathname==='/menu')
        {
            setShoppingBasket(false)
            setDashboard(false)
            setMenu(true)  
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[window.location.pathname])

        const[ShoppingBasket,setShoppingBasket]=useState(false)
        const[dashbord,setDashboard]=useState(true)
        const[Menu,setMenu]=useState(false)
    return (
        <nav className={Style.NavbarHolder}>
            <Link to="/" className={dashbord?Style.onFocus:null}><FontAwesomeIcon icon={faChartBar}/>داشبورد</Link>
            <Link to="/menu" className={Menu?Style.onFocus:null}><FontAwesomeIcon icon={faListUl}/>منو</Link>
            <Link to="/orders" className={ShoppingBasket?Style.onFocus:null}><FontAwesomeIcon icon={faShoppingBasket}/>سفارشات</Link>
        </nav>
    )
}

export default BottomNavigation
